<template>

	<div style="max-width: 100%;position: relative;overflow: hidden;margin-bottom: 4px;cursor: pointer;"
		@mouseenter.stop.prevent="isEnter = true" @mouseleave.stop.prevent="isEnter = false" :style="{
		...getBorderRadius(),
		...getBorder(),
		...getHoverBorder(),
		...getBgColor(),
		...getPadding()
	}">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<div
			style="width: 100%; position: relative;display: flex;justify-content: center;flex-direction: column;align-items: center;">
			<div style="max-width: 100%;display: flex;justify-content: center;align-items: center; min-height: 0; " :style="{
				aspectRatio: getAspectRatioImg(selectdItem.compontChildren[0].layoutConfig.goodsConfig),
				width: equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.goodsConfig.width + 'px' : selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneWidth + 'px',
			}">
				<img loading="lazy" @click="nanTo()" :style="{
					aspectRatio:getAspectRatio(selectdItem.compontChildren[0].layoutConfig.goodsConfig),
					objectFit:selectdItem.compontChildren[0].layoutConfig.goodsConfig.mode?selectdItem.compontChildren[0].layoutConfig.goodsConfig.mode:'cover',
				}" style="max-width: 100%;" :src="goodsData.image_format" />
			</div>
			<div v-if="getShowBtn() && selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.position == '1'"
				:style="{
				backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.bgColor,
			}" style="width: 100%;position: absolute;bottom: 0px;display: flex;align-items: center;min-height: 34px;">
				<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnShow"
					@click="addCart(goodsData)" :style="{
					fontSize:`${equipment =='pc'? selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartSize:(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartSize - 2)}` + 'px',
					color:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartColor,
					fontFamily:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartFamily,
					borderRight:`solid ${selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow || selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnShow?'1px':'0px'} ${selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.rightBorderColor}`,
					width:getAddCartWidth(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn),
					...getBtnBgColor(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn,'addCartBtnBg')
				}" style="text-align: center;height: 100%;display: flex;justify-content: center;align-items: center;cursor: pointer;min-height: 34px;">
					{{$t('h.addCart')}}
				</div>
				<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnShow"
					@click="buyNow(goodsData)" :style="{
				 	fontSize:`${equipment =='pc'?selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowSize:(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowSize - 2)}` + 'px',
				 	color:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowColor,
				 	fontFamily:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowFamily,
					borderRight:`solid ${selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow?'1px':'0px'} ${selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.rightBorderColor}`,
					width:getBuyNowWidth(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn),
					...getBtnBgColor(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn,'buyNowBtnBg')
				 }" style="text-align: center;height: 100%;display: flex;justify-content: center;align-items: center;cursor: pointer;min-height: 34px;">
					{{$t('h.buyNow')}}
				</div>
				<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow"
					@click="collect(goodsData)" :style="{
				 	fontSize:`${equipment == 'pc'?selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeSize: (selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeSize - 2)}` + 'px',
				 	color:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeColor,
				 	fontFamily:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeFamily,
					width:getLikeWidth(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn),
					...getBtnBgColor(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn,'likeBtnBg')
				 }" style="text-align: center;height: 100%;display: flex;justify-content: center;align-items: center;cursor: pointer;min-height: 34px;">
					<i class="el-icon-star-off"></i>
				</div>
			</div>
		</div>
		<div style="width: 100%;margin-top: 4px;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleShow" class="tit tit-item"
				style="width: 100%;text-align: center;margin: 4px;"
				:style="{
					fontSize:`${equipment =='pc'? selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleSize:(selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleSize - 2)}` + 'px',
					color:getColor(selectdItem.compontChildren[0].layoutConfig.goodsConfig.font,'titleColor','titleHoverColor'),fontFamily:selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleFamily}">
				{{goodsData.name}}
			</div>
			<div
				style="display: flex;align-items: center;width: 100%;justify-content: center;margin-top: 4px;margin-bottom: 4px;">
				<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountShow"
					:style="{
						fontSize:`${equipment =='pc'? selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountPriceSize:(selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountPriceSize - 2)}` + 'px',
						color:getColor(selectdItem.compontChildren[0].layoutConfig.goodsConfig.font,'discountPriceColor','discountPriceHoverColor'),fontFamily:selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountPriceFamily}">
					{{goodsData.price_format}}
				</div>
				<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalShow && goodsData.origin_price > 0"
					:style="{
						fontSize:`${equipment =='pc'? selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalPriceSize:(selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalPriceSize - 2)}` + 'px',
						color:getColor(selectdItem.compontChildren[0].layoutConfig.goodsConfig.font,'originalPriceColor','originalPriceHoverColor'),fontFamily:selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalPriceFamily}"
					style="margin-left: 20px; text-decoration: line-through;">{{goodsData.origin_price_format}}</div>
			</div>
			<div v-if="getShowBtn() && selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.position == '2'"
				:style="{
				backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.bgColor,
				position:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnHoverShow?'absolute':'static'
			}" style="width: 100%;bottom: 0px;display: flex;align-items: center;">
				<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnShow"
					@click="addCart(goodsData)" :style="{
					fontSize:`${equipment =='pc'? selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartSize:(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartSize - 2)}` + 'px',
					color:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartColor,
					fontFamily:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartFamily,
					borderRight:`solid 1px ${selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.rightBorderColor}`,
					width:getAddCartWidth(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn),
					...getBtnBgColor(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn,'addCartBtnBg')
				}" style="text-align: center;height: 100%;display: flex;justify-content: center;align-items: center;cursor: pointer;padding: 8px 0px;">
					{{$t('h.addCart')}}
				</div>
				<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnShow"
					@click="buyNow(goodsData)" :style="{
				 	fontSize:`${equipment =='pc'? selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartSize:(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartSize - 2)}` + 'px',
				 	color:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowColor,
				 	fontFamily:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowFamily,
					borderRight:`solid 1px ${selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.rightBorderColor}`,
					width:getBuyNowWidth(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn),
					...getBtnBgColor(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn,'buyNowBtnBg')
				 }" style="text-align: center;height: 100%;display: flex;justify-content: center;align-items: center;cursor: pointer;padding: 8px 0px;">
					{{$t('h.buyNow')}}
				</div>
				<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow"
					@click="collect(goodsData)" :style="{
				 	fontSize:`${equipment =='pc'? selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartSize:(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartSize - 2)}` + 'px',
				 	color:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeColor,
				 	fontFamily:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeFamily,
					width:getLikeWidth(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn),
					...getBtnBgColor(selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn,'likeBtnBg')
				 }" style="text-align: center;height: 100%;display: flex;justify-content: center;align-items: center;cursor: pointer;padding: 8px 0px;">
					<div><i class="el-icon-star-off"></i></div>
				</div>
			</div>
		</div>



		<el-dialog title="" :visible.sync="dialogVisible" :width="equipment == 'phone'?'90%':'60%'"
			:before-close="()=>{dialogVisible = false}">
			<div v-loading="iframeLogin">
				<iframe v-if="dialogVisible" id="iframe" style="width: 100%;min-height: 650px;" ref="iframe"
					src="/login?iframe=true" frameborder="0" scrolling="auto" @load="iframeLogin = false"></iframe>
			</div>
		</el-dialog>
	</div>

</template>

<script>
	import {
		Select
	} from 'element-ui'
	
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import {
		getProductsAutocomplete,
		getproductsDetail,
		getDesignProductsDetail,
		getAccountAddCarts,
		getAccountCollect
	} from '../../api/all.js'

	export default {
		props: {
			goodsData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},
		
		data() {
			return {
				loading: false,
				dialogVisible: false,
				iframeLogin: false,
				isEnter: false
			}
		},
		computed: {
			...mapState("lowCodeStore", ['cartNum']),
		},
		mounted() {
			console.log('systemConfig', this.systemConfig)
			window.addEventListener('message', this.handleMessage);
		},
		beforeDestroy() {
			window.removeEventListener('message', this.handleMessage);
		},
		methods: {
			...mapMutations("lowCodeStore", ["setSelectdItem", "setCenterList", "setList"]),
			getAspectRatioImg(item){
				
				if(this.equipment == 'pc'){
					if(item.width == item.height) {
						return `1/1`
					}else{
						return `${item.width} / ${item.height}`
					}
				}else{
					if(item.phoneWidth == item.phoneHeight) {
						return `1/1`
					}{
						return `${item.phoneWidth} / ${item.phoneHeight}`
					}
				}
				
			},
			getAspectRatio(item) {
				console.log('${item.width} / ${item.height}',`${item.width} / ${item.height}`)
				if(this.equipment == 'pc'){
					return `${item.width} / ${item.height}`
				}else{
					return `${item.phoneWidth} / ${item.phoneHeight}`
				}
			},
			handleMessage(event) {
				let that = this
				console.log('eventeventevent', event)
				if (event && event.data.type == 'apiLoginResponse' && event.data.data.status == "success") {
					that.dialogVisible = false
					localStorage.setItem('address', JSON.stringify(event.data.data.data))
					// that.$message.success(event.data.data.message)
				}
			},


			nanTo() {
				if (this.type == 'design') {
					return
				}
				this.$router.push({
					path: '/products/' + this.goodsData.url_name
				})
			},
			getLikeWidth(btn) {
				if (!btn.buyNowBtnShow && !btn.addCartBtnShow) {
					return '100%'
				} else {
					return '15%'
				}
			},
			getAddCartWidth(btn) {
				if (!btn.buyNowBtnShow && !btn.likeBtnShow) {
					return '100%'
				}
				if (btn.buyNowBtnShow && btn.likeBtnShow) {
					return '45%'
				}
				if (btn.buyNowBtnShow && !btn.likeBtnShow) {
					return '50%'
				}
				if (!btn.buyNowBtnShow && btn.likeBtnShow) {
					return '85%'
				}
			},
			getBuyNowWidth(btn) {
				if (!btn.addCartBtnShow && !btn.likeBtnShow) {
					return '100%'
				}
				if (btn.addCartBtnShow && btn.likeBtnShow) {
					return '40%'
				}

				if (btn.addCartBtnShow && !btn.likeBtnShow) {
					return '50%'
				}

				if (!btn.addCartBtnShow && btn.likeBtnShow) {
					return '85%'
				}
			},
			async collect(goodsData) {
				console.log('goodsData', goodsData)
				try {
					if (this.type == 'design') {
						return
					}
					this.loading = true
					let data = await getAccountCollect({
						product_id: goodsData.id
					})
					this.$message.success(data.data.message)
					this.loading = false
					this.isCollct = !this.isCollct
				} catch (e) {
					if (e.status == 401) {
						this.dialogVisible = true
						this.iframeLogin = true
					}
					console.log('e', e)
					this.loading = false
				}
			},

			async addCart(item) {
				if (this.type == 'design') {
					return
				}
				console.log('addCartitem', item)
				try {
					this.loading = true
					let data = await getAccountAddCarts({
						buy_now: false,
						sku_id: item.sku_id,
						quantity: 1
					})
					
					this.setList({
						filed:"cartNum",
						list:parseInt(this.cartNum) + 1,
					})
					
					this.$message.success(data.data.message)
					this.loading = false
				} catch (e) {
					this.loading = false
				}

			},
			async buyNow(item) {
				try {
					if (this.type == 'design') {
						return
					}
					console.log(this.sku)
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await getAccountAddCarts({
						buy_now: true,
						sku_id: item.sku_id,
						quantity: 1
					})
					this.$router.push({
						path: '/checkout'
					})
					this.loading = false
				} catch (e) {
					console.log('e', e)
					// this.$message.error(e.response.data.message)
					this.loading = false
				}
			},
			getShowBtn() {
				let btn = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn
				if (btn.btnShow) {
					if (btn.btnHoverShow) {
						return this.isEnter
					}
					return true
				} else {
					return false
				}
			},
			getPadding() {
				let padding = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.padding
				let style = {
					paddingTop: padding[0] + 'px',
					paddingBottom: padding[1] + 'px',
					paddingLeft: padding[2] + 'px',
					paddingRight: padding[3] + 'px'
				}
				return style
			},
			getBtnBgColor(btn, field) {
				if (btn[field].type == '1') {
					return {
						backgroundColor: btn[field].bgColor
					}
				} else {
					return {
						...this.cssStringToObject(btn[field].gradientColor)
					}
				}
			},

			getBgColor() {
				let bg = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg
				if (bg.type == '1') {
					return {
						backgroundColor: bg.color
					}
				}
				if (bg.type == '2') {
					return this.cssStringToObject(bg.gradientColor)
				}


			},
			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},
			getHoverBorder() {
				if (this.isEnter && this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.hoverShadow) {
					return {
						boxShadow: `0 0 10px 1px ${this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.hoverShadowColor}`
					}
				}
			},
			getColor(font, field, hoverField) {
				if (this.isEnter) {
					if (font[hoverField]) {
						return font[hoverField]
					} else {
						return font[field]
					}
				} else {
					return font[field]
				}
			},

			getBorderRadius() {
				let style = {}
				style.borderRadius =
					`${this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius[0]}px ${this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius[1]}px ${this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius[2]}px ${this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius[3]}px`
				console.log('getBorderRadius', style)
				return style
			},
			getBorder() {
				let border = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border
				if (border.type && border.color) {
					let style = {}
					style.borderTop =
						`${border.type} ${border.borderSize[0]}px ${border.color}`
					style.borderLeft =
						`${border.type} ${border.borderSize[1]}px ${border.color}`
					style.borderBottom =
						`${border.type} ${border.borderSize[2]}px ${border.color}`
					style.borderRight =
						`${border.type} ${border.borderSize[3]}px ${border.color}`
					return style
				}
			},
		}
	}
</script>

<style scoped>
	.tit {
		overflow: hidden;
		/* 隐藏溢出内容 */
		white-space: nowrap;
		/* 禁止换行 */
		text-overflow: ellipsis;
		/* 显示省略号 */
	}
</style>